import { BasketballAssessment } from 'types/api';
import { GraphTabs } from 'components/GraphTabs';
import styles from './Mechanics.module.css';
import { useConfig } from './useConfig';
import { useRightFootData } from './useRightFootData';

interface RightFootProps {
  assessments: BasketballAssessment[];
  className?: string;
}

export const RightFootCompare = (props: RightFootProps) => {
  const { assessments, className } = props;
  const data = useRightFootData(assessments);
  const config = useConfig('Right Foot Mechanics', assessments, data);
  return (
    <GraphTabs
      className={className}
      config={config}
      defaultTab="lineTab"
      headerClassName={styles.header}
      heading="Right Foot Mechanics"
    />
  );
};
